import {
  AllCandidateBLASTUiParamsType,
  CommonBLASTParamValues,
  MatrixToGapCosts,
  UnwrappedBLASTParamsType,
} from 'search/blast/parameters/common';
import {BLASTMatrix, BLASTXTask} from 'search/SearchConstants';
import pickDefined from 'util/pickDefined';

export type CandidateBLASTXUiParamsType = Pick<
  AllCandidateBLASTUiParamsType<BLASTXTask>,
  'task' | 'evalue' | 'word_size' | 'culling_limit' | 'gap_cost' | 'strand' | 'matrix' | 'comp_based_stats'
>;

export type BLASTXUiParamsType = UnwrappedBLASTParamsType<CandidateBLASTXUiParamsType>;

const CommonBLASTXParams: Pick<
  CandidateBLASTXUiParamsType,
  'evalue' | 'culling_limit' | 'gap_cost' | 'strand' | 'matrix' | 'comp_based_stats'
> = {
  ...pickDefined(
    CommonBLASTParamValues,
    'evalue',
    'culling_limit',
    'gap_cost',
    'strand',
    'matrix',
    'comp_based_stats'
  ),
};

export const DefaultBLASTXParams: CandidateBLASTXUiParamsType = {
  ...CommonBLASTXParams,
  task: {defaultValue: BLASTXTask.BLASTX, values: Object.values(BLASTXTask)},
  word_size: {
    values: [2, 3, 4, 6],
    defaultValue: 3, // from the blastp program, not from NCBI
  },
};

export const DefaultBLASTXFastParams: CandidateBLASTXUiParamsType = {
  ...CommonBLASTXParams,
  task: {defaultValue: BLASTXTask.BLASTXFast, values: Object.values(BLASTXTask)},
  word_size: {
    values: [2, 3, 4, 6],
    defaultValue: 6, // from the blastp program, not from NCBI
  },
};

export const getCandidateBLASTXUiParams = (
  task?: BLASTXTask,
  matrix?: BLASTMatrix
): CandidateBLASTXUiParamsType => {
  if (!matrix) {
    switch (task) {
      case BLASTXTask.BLASTXFast:
        return DefaultBLASTXFastParams;
      default:
        return DefaultBLASTXParams;
    }
  } else {
    const baseParams = getCandidateBLASTXUiParams(task);
    return {
      ...baseParams,
      matrix: {
        ...baseParams.matrix,
        defaultValue: matrix,
      },
      gap_cost: MatrixToGapCosts[matrix],
    };
  }
};
